import googleIcon from "./../icons/Google.svg";
import facebookIcon from "./../icons/Facebook.svg";
import instagramIcon from "./../icons/Instagram.svg";
import { LogoLink } from "./LogoLink";

interface IProps {
  facebookLink?: string;
  instagramLink?: string;
  googleLink?: string;
}

export const SocialLinks = ({
  facebookLink,
  instagramLink,
  googleLink,
}: IProps) => {
  const isVisible = facebookLink || instagramLink || googleLink;

  const socials = (
    <ul className={"flex flex-row gap-8"}>
      <li>
        {facebookLink && (
          <LogoLink href={facebookLink} src={facebookIcon} alt={"facebook"} />
        )}
      </li>
      {instagramLink && (
        <LogoLink href={instagramLink} src={instagramIcon} alt={"instagram"} />
      )}
      {googleLink && (
        <LogoLink href={googleLink} src={googleIcon} alt={"google"} />
      )}
    </ul>
  );

  return <>{isVisible && socials}</>;
};
